import BarChart from "../../common/Charts/BarChart";
import ColumnChart from "../../common/Charts/ColumnChart";
import LineChart from "../../common/Charts/LineChart";
import PieChart from "../../common/Charts/PieChart";
import AreaChart from "../../common/Charts/AreaChart";
import { Calendar, Typography } from "antd";
import {
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import moment from 'moment';
import {
  AreaLineAnnotation,
  columnCornerRadius,
  columnStackedPlot,
  donatPlotAction,
  groupBarPlot,
  GroupedColumnStackedConfig,
  lineMullitpleAnimation,
  linePlotAction,
  pieLegendAction,
} from "../../common/DashboardChartConfig/ChartConfig";
import { apsisEncrypt } from "../../helpers/apsisEncryption";
import { useHistory } from "react-router-dom";
import { CardContentWrap, CardV2Wrapper } from "../styles";
import { TableGrid } from "./TableGrid";
import React from "react";
import { useSelector } from "react-redux";
import { shallowEqual } from "react-redux";
import { useDispatch } from "react-redux";
import * as Action from "../../../app/pages/dashboard/_redux/dashboardAction";
import { useEffect } from "react";
import { LeaveWidget } from "../CustomWidget/LeaveWidget";
import { ProfileWidget } from "../CustomWidget/ProfileWdiget";
import { AttendanceWidget } from "../CustomWidget/AttendanceWidget";
import { PayslipWidget } from "../CustomWidget/PayslipWidget";
import { ReportsToWidget } from "../CustomWidget/ReportsToWidget";
import { ProfileWidgetV2 } from "../CustomWidget/ProfileWdigetV2";
import BirthdayWidget from "../CustomWidget/BirthdayWidget";
import MyTeamWidget from "../CustomWidget/MyTeamWidget";
import TeamAttendanceWidget from "../CustomWidget/TeamAttendanceWidget";
import TaxCertificateWidget from "../CustomWidget/TaxCertificateWidget";
export const DynamicContent = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    user,
    auth,
    weekend,
    holidayLists,
  } = useSelector(
    ({ auth, dashboard }) => ({
      user: auth.coreModuleInfo,
      auth: auth.coreModuleInfo,
      weekend: dashboard?.weekend,
      holidayLists: dashboard?.holidayLists,
    }),
    shallowEqual
  );

  const {
    chartItem: {
      widget_type,
      data,
      widget_config,
      dashboard_widget_id,
      theme,
      action_url,
      card_bg_color,
    },
    tblView,
  } = props;
  const goMasterList = (slug, action_url) => {
    if (action_url) {
      history.push(action_url);
    } else if (slug) {
      history.push(`/dashboard/list?slug=${apsisEncrypt(slug)}`);
    } else {
      history.push(`/`);
    }
  };
  useEffect(() => {
    const calenderPayload = {
      employee_ids: auth?.employee_id,
      end_date: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      start_date: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
    };
    const holidayPayload = {
      year: moment().year(),
      month: moment().month(),
    };
    if(widget_type=="Holidays"){
      dispatch(Action.getCalender(calenderPayload));
      dispatch(Action.getHolidays(holidayPayload));
    }
  }, []);

  return (
    <div>
      {(() => {
        switch (widget_type) {
          case "Line": {
            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <LineChart
                    config={{
                      data,
                      ...widget_config,
                      ...lineMullitpleAnimation,
                    }}
                  />
                )}
              </>
            );
          }

          case "Area": {
            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <AreaChart
                    config={{
                      data,
                      ...widget_config,
                      ...AreaLineAnnotation,
                    }}
                  />
                )}
              </>
            );
          }

          case "MultiArea": {
            const xField = widget_config.xField;
            const transformedData = data?.flatMap((item) => {
              const metrics = Object.keys(item).filter((key) => key !== xField);

              return metrics.map((metric) => ({
                req_month: item.req_month.trim(),
                value: item[metric],
                category: metric,
              }));
            });

            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <AreaChart
                    config={{
                      data: transformedData,
                      ...widget_config,
                      ...AreaLineAnnotation,
                      yField: "value",
                      seriesField: "category",
                    }}
                  />
                )}
              </>
            );
          }

          case "Bar": {
            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <BarChart
                    config={{
                      data,
                      ...widget_config,
                      ...groupBarPlot,
                    }}
                  />
                )}
              </>
            );
          }

          case "Column Radius": {
            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <ColumnChart
                    config={{
                      data,
                      ...widget_config,
                      ...columnCornerRadius,
                    }}
                  />
                )}
              </>
            );
          }

          case "Stacked Column": {
            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <ColumnChart
                    config={{
                      data,
                      ...widget_config,
                      ...columnStackedPlot,
                    }}
                  />
                )}
              </>
            );
          }
          case "Grouped Stacked Column": {
            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <ColumnChart
                    config={{
                      data,
                      ...widget_config,
                      ...GroupedColumnStackedConfig,
                    }}
                  />
                )}
              </>
            );
          }

          case "Pie": {
            const transformedPieData = data?.map((item) => {
              const transformed = { ...item };
              // Convert all numeric string values to actual numbers
              Object.keys(transformed).forEach((key) => {
                if (
                  typeof transformed[key] === "string" &&
                  !isNaN(transformed[key])
                ) {
                  transformed[key] = parseFloat(transformed[key]);
                }
              });
              return transformed;
            });

            // Fix the angleField typo if it exists (total_employeess -> total_employees)
            const correctedConfig = { ...widget_config };
            if (correctedConfig.angleField === "total_employeess") {
              correctedConfig.angleField = "total_employees";
            }
            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <PieChart
                    config={{
                      // data,
                      // ...widget_config,
                      data: transformedPieData,
                      ...correctedConfig,
                      ...pieLegendAction,
                    }}
                  />
                )}
              </>
            );
          }
          case "Line Plot": {
            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <LineChart
                    config={{
                      data,
                      ...widget_config,
                      ...linePlotAction,
                    }}
                  />
                )}
              </>
            );
          }
          case "Donat Plot": {
            return (
              <>
                {dashboard_widget_id === tblView ? (
                  <TableGrid currentComponent={data} />
                ) : (
                  <PieChart
                    config={{
                      data,
                      ...widget_config,
                      ...donatPlotAction,
                    }}
                  />
                )}
              </>
            );
          }
          case "MasterGrid View": {
            return (
              <>
                <TableGrid currentComponent={data} />

              </>
            );
          }
          case "Birthday": {
            return (
              <>
                <BirthdayWidget birthdayData={data}/>
              </>
            );
          }
          case "Gender Card": {
            const maleData = data?.find(
              (item) => item.title?.toLowerCase() === "male",
            );
            const femaleData = data?.find(
              (item) => item.title?.toLowerCase() === "female",
            );
            return (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    height: "100%",
                    padding: "20px",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <h6>
                      <b>Male</b> {maleData?.value}%
                    </h6>
                  </div>
                  <div>
                    <img
                      src="/images/gender.png"
                      width="120"
                      alt="gender-ico"
                    />
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <h6>
                      <b>Female</b> {femaleData?.value}%
                    </h6>
                  </div>
                </div>
              </>
            );
          }
          case "Holidays": {
            return (
              <>
                <Calendar
                  fullscreen={false}
                  dateFullCellRender={(date) => {
                    const formattedDate = date.format("YYYY-MM-DD");
                    const holidays = holidayLists.map((item) => item.date_is);
                    const isHoliday = holidays.includes(formattedDate);
                    const isWeekend = weekend.includes(formattedDate);

                    const color = isHoliday
                      ? "#f39822"
                      : isWeekend
                        ? "#ff4d4f"
                        : undefined;

                    const fontWeight = isHoliday
                      ? "600"
                      : isWeekend
                        ? "600"
                        : "500";

                    return (
                      <div
                        className="ant-picker-cell-inner"
                        style={{ color, fontWeight }}
                      >
                        {date.date()}
                      </div>
                    );
                  }}
                headerRender={({ value, type, onChange, onTypeChange }) => {
                  const current = value.clone();

                  const prevMonth = () => {
                    const newValue = current.clone().subtract(1, "month");
                    onChange(newValue);

                    const calenderPayload = {
                      employee_ids: user?.employee_id,
                      end_date: moment(newValue)
                        .endOf("month")
                        .format("YYYY-MM-DD"),
                      start_date: moment(newValue)
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    };
                    const holidayPayload = {
                      year: moment(newValue).year(),
                      month: moment(newValue).month(),
                    };
                    dispatch(Action.getHolidays(holidayPayload));
                    dispatch(Action.getCalender(calenderPayload));
                  };

                  const nextMonth = () => {
                    const newValue = current.clone().add(1, "month");
                    onChange(newValue);

                    const calenderPayload = {
                      employee_ids: user?.employee_id,
                      end_date: moment(newValue)
                        .endOf("month")
                        .format("YYYY-MM-DD"),
                      start_date: moment(newValue)
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    };

                    const holidayPayload = {
                      year: moment(newValue).year(),
                      month: moment(newValue).month(),
                    };

                    dispatch(Action.getCalender(calenderPayload));
                    dispatch(Action.getHolidays(holidayPayload));
                  };

                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingBottom: 8,
                        flexWrap: "nowrap", // 👈 prevents wrapping
                      }}
                    >
                      <Typography.Title
                        level={4}
                        style={{
                          margin: 0,
                          fontSize: "18px", // 👈 shrink font a bit for small screens
                          whiteSpace: "nowrap", // 👈 keep text on one line
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {moment(value).format("MMM YYYY")}
                      </Typography.Title>

                      <div style={{ display: "flex", gap: "10px" }}>
                        <button
                          className="btn cursor-pointer"
                          onClick={prevMonth}
                        >
                          <FaChevronLeft style={{ fontSize: "20px" }} />
                        </button>
                        <button
                          className="btn cursor-pointer"
                          onClick={nextMonth}
                        >
                          <FaChevronRight style={{ fontSize: "20px" }} />
                        </button>
                      </div>
                    </div>
                  );
                }}
                />
                {holidayLists?.length > 0 && (
                  <div className="d-flex align-items-center">
                    <h4 className="mr-4">Holidays</h4>
                    <ul
                      style={{
                        fontSize: 13,
                        marginTop: 12,
                        paddingLeft: 16,
                        listStyle: "none",
                        borderLeft: "1.5px solid #000",
                      }}
                    >
                      {holidayLists?.map((item, i) => (
                        <li key={i}>
                          {moment(item?.date_is).format("DD MMM")} —{" "}
                          {item?.calender_details}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </>
            );
          }
          case "CardV2": {
            return (
              <>
                {data?.map((item) => {
                  // Determine icon and colors based on theme or item properties
                  const getIconConfig = () => {
                    switch (theme) {
                      case "successColor":
                        return {
                          icon: item.icon_class || "fa fa-check-circle",
                          iconColor: "#369b00",
                          iconBgColor: "#deffcd",
                        };
                      case "Warning":
                        return {
                          icon: item.icon_class || "fa fa-exclamation-triangle",
                          iconColor: "#e69b00",
                          iconBgColor: "#fff0d1",
                        };
                      case "infoColor":
                        return {
                          icon: item.icon_class || "fa fa-info-circle",
                          iconColor: "#2095ff",
                          iconBgColor: "#dceeff",
                        };
                      default:
                        return {
                          icon: item.icon_class || "fa fa-file-text",
                          iconColor: "#ffffff",
                          iconBgColor: theme,
                        };
                    }
                  };

                  const iconConfig = getIconConfig();

                  return (
                    <CardV2Wrapper
                      key={item.slug}
                      iconColor={iconConfig.iconColor}
                      iconBgColor={iconConfig.iconBgColor}
                      cardBgColor={card_bg_color || "#ffffff"}
                    >
                      <div
                        className="icon-container"
                        onClick={() => goMasterList(item.slug)}
                      >
                        <i className={iconConfig.icon}></i>
                      </div>
                      <div className="content-wrapper">
                        <h3 className="title">{item.title}</h3>
                        <div className="value-wrapper">
                          {/* <i className="fa fa-arrow-up arrow-icon"></i> */}
                          <h2
                            className="value"
                            onClick={() => goMasterList(item.slug)}
                          >
                            {item.value}
                          </h2>
                        </div>
                        <p className="description">{item.subtitle || ""}</p>
                      </div>
                    </CardV2Wrapper>
                  );
                })}
              </>
            );
          }
          case "Profile Widget": {
            return (
              <>
                <ProfileWidgetV2 profileData={data}/>
              </>
            );
          }
          case "Profile Widget First": {
            return (
              <>
                <ProfileWidget profileData={data}/>
              </>
            );
          }
          case "Reporting To Widget": {
            return (
              <>
                <ReportsToWidget reportsToData={data}/>
              </>
            );
          }
          case "Leave Widget": {
            return (
              <>
                <LeaveWidget/>
              </>
            );
          }
          case "Attendance Widget": {
            return (
              <>
                <AttendanceWidget />
              </>
            );
          }
          case "Payslip Widget": {
            return (
              <>
                <PayslipWidget/>
              </>
            );
          }
          case "Tax Widget":
          case "Tax Certificate": {
            return (
              <>
                <TaxCertificateWidget />
              </>
            );
          }
          case "My Team Widget": {
            return (
              <>
                <MyTeamWidget teamData={data}/>
              </>
            );
          }
          case "Team Attendance Widget": {
            return (
              <>
                <TeamAttendanceWidget teamAttendanceData={data} loading={false}/>
              </>
            );
          }
          // by default Card component will be visible Warning
          default: {
            return (
              <>
                {data?.map((item) => {
                  return (
                    <CardContentWrap
                      key={item.slug}
                      theme={theme}
                      onClick={() => goMasterList(item.slug, action_url)}
                    >
                      <h2 className="font-bold">{item.value}</h2>
                      <p className="text-center">{item.title}</p>
                    </CardContentWrap>
                  );
                })}
              </>
            );
          }
          // code block
        }
      })()}
    </div>
  );
};
